import ListIcon from '@mui/icons-material/List';
import AttributeList from './AttributesList';
import AttributeEdit from './AttributeEdit';

export default {
    icon: ListIcon,
    list: AttributeList,
    edit: AttributeEdit,
};
